import React, { Component } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import AsyncSelect from '../Select/AsyncSelect';

export default class LocalitiesAutocomplete extends Component {
    constructor(props) {
        super(props);
        const { defaultLocality } = props;
        this.state = {
            localities: null,
            selectedLocality: defaultLocality
                ? {
                      value: defaultLocality.public_id,
                      label: defaultLocality.description,
                  }
                : null,
            menuIsOpen: false,
            input: '',
        };
        this.apiUrl = 'https://api.woosmap.com/localities/autocomplete';
    }

    getRequestparams = () => {
        const { woosmapKey } = this.props;
        return {
            key: woosmapKey,
        };
    };

    getAutocompleteRequestparams = () => {
        const { language, components, types } = this.props;
        const { input } = this.state;
        const { woosmapKey } = this.props;
        const inputValue = input;
        const params = {
            key: woosmapKey,
            input: inputValue,
            language,
        };
        if (components) {
            params.components = components;
        }
        if (types) {
            params.types = types;
        }
        return params;
    };

    onInputChange = (value) => {
        const { inputChangeCb } = this.props;

        if (inputChangeCb) {
            inputChangeCb(value);
        }
    };

    onChange = (selected) => {
        const { callback } = this.props;
        const { localities } = this.state;
        let item = null;
        if (selected) {
            item = localities.find((locality) => locality.public_id === selected.value);
        }
        this.setState(
            {
                selectedLocality: item,
                menuIsOpen: false,
            },
            () => {
                const { selectedLocality } = this.state;
                callback(selectedLocality);
            }
        );
    };

    loadLocalities = (newValue, callback) => {
        const xhr = () => {
            const params = this.getAutocompleteRequestparams(newValue);
            axios
                .get(this.apiUrl, {
                    params,
                })
                .then((response) => {
                    const result = response.data.localities.map((item) => ({
                        value: item.public_id,
                        label: item.description,
                    }));
                    this.setState({ localities: response.data.localities }, () => {
                        const { responseCb } = this.props;
                        if (responseCb) {
                            responseCb(response.data.localities);
                        }
                    });
                    callback(result);
                })
                .catch(() => {
                    // do nothing
                });
        };
        this.setState({ menuIsOpen: true, input: newValue }, xhr);
    };

    render() {
        const { selectedLocality, menuIsOpen } = this.state;
        const { placeholder, inputRef } = this.props;
        return (
            <AsyncSelect
                blurInputOnSelect
                innerRef={inputRef}
                isClearable
                loadOptions={this.loadLocalities}
                onChange={this.onChange}
                onInputChange={this.onInputChange}
                placeholder={placeholder}
                onBlur={() => this.setState({ menuIsOpen: false })}
                menuIsOpen={menuIsOpen}
                defaultValue={selectedLocality}
            />
        );
    }
}

LocalitiesAutocomplete.defaultProps = {
    placeholder: 'Type in a locality',
    defaultLocality: null,
    language: null,
    components: null,
    types: null,
    inputRef: null,
    inputChangeCb: null,
    responseCb: null,
};
LocalitiesAutocomplete.propTypes = {
    woosmapKey: PropTypes.string.isRequired,
    inputRef: PropTypes.object,
    placeholder: PropTypes.string,
    components: PropTypes.string,
    types: PropTypes.string,
    language: PropTypes.string,
    callback: PropTypes.func.isRequired,
    defaultLocality: PropTypes.object,
    inputChangeCb: PropTypes.func,
    responseCb: PropTypes.func,
};
